export default "__VITE_PUBLIC_ASSET__edc9b16e__"